import React from 'react';

import { Box, Divider, Grid } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';

const HeaderContainer = ({
    children,
    hasDivider = false,
    hidden = false,
    sxHeader,
}) => (
    <Box hidden={hidden}>
        <Grid
            container
            sx={{
                alignItems: 'center',
                display: 'flex',
                paddingBottom: '1rem',
                paddingTop: '1rem',
                ...sxHeader,
            }}
        >
            {children}
        </Grid>

        {hasDivider && <Divider sx={{ marginBottom: '1.5rem' }} />}
    </Box>
);

HeaderContainer.propTypes = {
    children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    hasDivider: PropTypes.bool,
    hidden: PropTypes.bool,
    sxHeader: PropTypes.object,
};

export default HeaderContainer;
